import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import apiConfig from "../config/api";
import store from "../store/index";
import { getInstance } from "../auth/index";
import { createAuthInterceptor, createTokenResolver } from "./authInterceptor";

Vue.use(VueAxios, axios);

// Vue.axios este instanta globala axios, deci interceptorul acopera si serviciile care importa axios direct
// (de exemplu incarcarea fisierelor). Tokenul pleaca doar catre adresa API-ului.
axios.interceptors.request.use(
  createAuthInterceptor({
    baseURL: apiConfig.baseURL,
    getToken: createTokenResolver({ getAuth: getInstance, store }),
  })
);

export default Vue.axios;
